// src/features/eventos/components/Field.jsx
import styles from "../../styles/evento-form.module.css";


export const Field = ({ label, hint, required, children }) => (
    <div className={styles.field}>
        {label && (
            <label className={styles.label}>
                {label} {required && <span className={styles.req}>(obligatorio)</span>}
            </label>
        )}
        {children}
        {hint && <div className={`${styles.assist} ${styles.hint}`}>{hint}</div>}
    </div>
);
